import { render } from "./ReVu.vue?vue&type=template&id=b6802d42&scoped=true&ts=true"
import script from "./ReVu.vue?vue&type=script&lang=ts"
export * from "./ReVu.vue?vue&type=script&lang=ts"

import "./ReVu.vue?vue&type=style&index=0&id=b6802d42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6802d42"]])

export default __exports__